import React from "react";
import "../assets/css/Carousel.css";

// Importation des images
import SelogerLogo from "../assets/img/logos/640px-Groupe_SeLoger.jpg";
import AtalianLogo from "../assets/img/logos/Atalian-Servest-Logo.png";
import BTPConsultantsLogo from "../assets/img/logos/BTPConsultants_Logotype_Couleur_RVB.png";
import DevoteamLogo from "../assets/img/logos/devoteam-logo.png";
import VeoliaLogo from "../assets/img/logos/kisspng-veolia-water-logo-business-management-outils-5b31c267c40b05.063317021529987687803.png";
import StellantisLogo from "../assets/img/logos/Stellantis.svg.png";

// Tableau d'images
const logos = [
  { src: SelogerLogo, alt: "Seloger" },
  { src: AtalianLogo, alt: "Atalian" },
  { src: BTPConsultantsLogo, alt: "BTP Consultants" },
  { src: DevoteamLogo, alt: "Devoteam" },
  { src: VeoliaLogo, alt: "Veolia" },
  { src: StellantisLogo, alt: "Stellantis" },
];

const Carousel = () => {
  return (
    <div className="carousel-container">
      <div className="carousel-slide">
        {/* Premier set d’images */}
        {logos.map((logo, index) => (
          <img key={index} src={logo.src} alt={logo.alt} />
        ))}
        {/* Deuxième set pour le défilement infini */}
        {logos.map((logo, index) => (
          <img key={`duplicate-${index}`} src={logo.src} alt={logo.alt} />
        ))}
        {/* Troisième set pour éviter un blanc sur mobile */}
        {logos.map((logo, index) => (
          <img key={`triplicate-${index}`} src={logo.src} alt={logo.alt} />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
